module.exports = __webpack_public_path__ + "images/table_bg_selected.jpg";